import { Button, Select, Space } from "antd";
import { useState } from "react";

export interface DocEditor {
  Id: string;
  date: string;
  displayName: string;
  email: string;
}

interface Props {
  docEditors?: DocEditor[];
  label?: string;
  onSubmit?: (keys: string[], docEditors: DocEditor[], options: { reset: () => void }) => void;
  disabled?: boolean;
}

const DecentralizeTitleTable = (props: Props) => {
  const { docEditors = [], label, onSubmit = () => {}, disabled } = props;
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const reset = () => {
    setSelectedKeys([]);
  };

  const onClick = () => {
    const filtered = selectedKeys.map((k) => docEditors.find((e) => e.Id === k)!);
    onSubmit(selectedKeys, filtered, { reset });
  };

  const options = docEditors?.map((item) => ({ label: item.displayName, value: item.Id }));
  const disabledButton = disabled || selectedKeys.length === 0;

  return (
    <>
      {label && <div>{label}</div>}
      <Space.Compact block>
        <Select
          disabled={disabled}
          mode="multiple"
          options={options}
          style={{ width: "100%" }}
          value={selectedKeys}
          onChange={(value) => setSelectedKeys(value)}
        />
        <Button disabled={disabledButton} type="primary" onClick={onClick}>
          Chọn
        </Button>
      </Space.Compact>
    </>
  );
};

export default DecentralizeTitleTable;
